<script>
export default {
  props: ['steps', 'currentStep', 'color'],
  computed: {
    currentStepIndex() {
      return this.steps.indexOf(this.currentStep);
    },
    barPercentage() {
      return (100 * this.currentStepIndex) / (this.steps.length - 1);
    },
  },
  data() {
    return {
      primaryColor: this.color || 'var(--primary)',
    };
  },
  methods: {
    getDotPercentageFor(index) {
      return (100 * (index + 0.5)) / this.steps.length;
    },
    getCenteringFor(index) {
      if (index === 0) return 'text-left';
      if (index === this.steps.length - 1) return 'text-right';
      return 'text-center';
    },
    getStatusClass(index) {
      if (index < this.currentStepIndex) return 'done';
      if (index === this.currentStepIndex) return 'active';
      return '';
    },
    adjustmentPercentage() {
      return 50 / (this.steps.length - 1);
    },
  },
};
</script>

<template>
  <div class="steps-progress-container">
    <div
      class="steps-progress-wrapper apply-progress-check-wrapper"
      :style="{
        width: `${100 + 2 * adjustmentPercentage()}%`,
        marginLeft: `-${adjustmentPercentage()}%`,
      }"
    >
      <div :style="{ padding: `0 ${50 / steps.length}%` }">
        <vs-progress
          class="bg-chrome-lightest"
          :height="8"
          :percent="barPercentage"
          :color="primaryColor"
        />
      </div>

      <div
        v-for="(step, index) in steps"
        style="flex: 1"
        :class="`progress-circle ${getStatusClass(index)}`"
        :style="{
          left: `calc(${getDotPercentageFor(index)}% - 6px)`,
          borderColor:
            index <= currentStepIndex ? primaryColor : 'var(--chrome-lightest)',
          backgroundColor: index < currentStepIndex ? primaryColor : 'white',
        }"
      >
        <span class="progress-check">
          <em
            v-if="index < currentStepIndex"
            class="feather icon-check icon checkmark"
            >&nbsp;</em
          >
        </span>
      </div>

      <div class="holder-information-wrapper">
        <div
          v-for="(step, index) in steps"
          :class="`holder-info text-center ${
            index <= currentStepIndex ? 'text-onyx' : 'text-onyx-lightest'
          }`"
        >
          {{ step }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scss scoped>
.steps-progress-container {
  padding: 0 25px;
  width: 100%;
  max-width: 360px;
  margin: 10px auto 16px;

  .steps-progress-wrapper {
    position: relative;
    margin: 0 auto;

    .progress-check {
      position: relative;
      color: white;
    }

    .progress-circle {
      top: 3px;
      width: 14px;
      height: 14px;
      content: counter(step);
      counter-increment: step;
      line-height: 30px;
      background-color: white;
      border: 4px solid var(--chrome-lightest);
      display: block;
      text-align: center;
      margin: 0 auto 10px auto;
      position: absolute;
      border-radius: 100%;
      z-index: 999;

      &.active {
        background-color: white;
        border: 4px solid rgba(var(--vs-primary), 1);
      }

      &.done {
        top: 2px;
        width: 16px;
        height: 16px;

        & .progress-check .checkmark {
          position: absolute;
          top: -3px;
          left: -7.5px;
        }
      }
    }
  }

  .holder-information-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 5px;

    .holder-info {
      flex: 1;
      font-family: 'Montserrat';
      font-size: 10px;
      font-weight: 700;
      line-height: normal;
      letter-spacing: normal;
      color: var(--onyx);
    }
  }
}
</style>
